import {
  Avatar,
  Box,
  ButtonBase,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import addURLPrefix from "utils/addURLPrefix";

const CategoryCard = ({
  category,
  handleContextMenu,
  handleClick,
  selectedItem,
  setSelectedItem,
}) => {
  return (
    <ButtonBase>
      <Paper
        sx={{
          height: 60,
          width: 220,
          ...(selectedItem?.id === category.id && {
            backgroundColor: "primary.lighter",
          }),
        }}
        onContextMenu={(e) => handleContextMenu(e, category)}
        elevation={selectedItem?.id === category.id ? 4 : 1}
        onClick={() => setSelectedItem(category)}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" borderRadius="50%">
            {category.image ? (
              <LazyLoadImage
                src={addURLPrefix(category.image)}
                height={60}
                width={80}
                style={{
                  padding: 1,
                  objectFit: "contain",
                  backgroundColor: "white",
                }}
                alt=""
              />
            ) : (
              <Avatar variant="square" sx={{ height: 60, width: 80 }}>
                {category.name[0]}
              </Avatar>
            )}
            <Typography marginX={1}>{category.name}</Typography>
          </Stack>
          <MoreVertIcon
            onClick={(e) => {
              e.stopPropagation();
              handleClick(e, category);
            }}
            sx={{ marginRight: 1 }}
            color="text.secondary"
          />
        </Stack>
      </Paper>
    </ButtonBase>
  );
};

export default CategoryCard;
